// Player colours, ported from the app's PeoplePalette (lib/theme/
// people_palette.dart) so a person is the same colour on every surface.
// Violet means you and nobody else; everyone else takes the palette in
// session join order, or a stable per-name pick outside a session.

export const ACCENT = "#a855f7";
export const MUTED_PERSON = "#5b5b66";
export const OTHERS = ["#ff9f43", "#2dd4bf", "#f472b6", "#60a5fa", "#a3e635"];
export const OTHERS_TINT = ["#fdba74", "#5eead4", "#f9a8d4", "#93c5fd", "#bef264"];
// Text on a person colour (initials): the app background.
export const ON_PERSON = "#0a0a0f";

const MASK = 0x00ffffffffffffffn;

// lib/utils/hash_color.dart strHash: 127 * (h & 0x00ff…ff) + codeUnit over
// UTF-16 code units. The products pass 2^53, so BigInt; they stay under
// 2^63, so Dart never wraps either.
export function strHashBig(str) {
  let h = 8381n;
  for (let i = 0; i < str.length; i++) {
    h = 127n * (h & MASK) + BigInt(str.charCodeAt(i));
  }
  return h;
}

export function strHashMod(str, n) {
  const m = BigInt(n);
  return Number(((strHashBig(str) % m) + m) % m);
}

// Out of a session (People, Home rows, Profile, search): stable per name,
// never violet unless the name is you.
export function forName(name, me) {
  if (me && name === me) return ACCENT;
  if (!name) return MUTED_PERSON;
  return OTHERS[strHashMod(name, OTHERS.length)];
}

function slot(i, name) {
  if (i < OTHERS.length) return OTHERS[i];
  if (i < OTHERS.length + OTHERS_TINT.length) return OTHERS_TINT[i - OTHERS.length];
  return forName(name);
}

// Session-scoped colours: you are violet, the others take OTHERS in join
// order, then the tints, then forName. Signed out (no `me`) nobody is you,
// so nobody is violet: everyone takes the others palette in join order.
export function assign(order, me) {
  const colors = {};
  if (me) colors[me] = ACCENT;
  let i = 0;
  for (const name of order) {
    if (!name || name in colors) continue;
    colors[name] = slot(i, name);
    i++;
  }
  return colors;
}

// Creator first, then users in list order (the backend appends on join),
// then loop creators missing from users, in library order.
export function joinOrder({ creator, users = [], loopCreators = [] }) {
  const seen = new Set();
  const out = [];
  for (const name of [creator, ...users, ...loopCreators]) {
    if (name && !seen.has(name)) {
      seen.add(name);
      out.push(name);
    }
  }
  return out;
}

export function initials(name) {
  const clean = (name || "").replace(/[^\p{L}\p{N} ]/gu, " ").trim();
  if (!clean) return "?";
  const parts = clean.split(/\s+/);
  const s = parts.length > 1 ? parts[0][0] + parts[1][0] : clean.slice(0, 2);
  return s.toUpperCase();
}
